export default {
  zoneGroupPeriods: null,
  zoneGroupToEdit: null,
  zoneGroupInfo: null,
  zoneGroupZoneInfo: null,
  zoneGroupMap: null,
  zoneGroupMapAction: null
}



// WEBPACK FOOTER //
// ./src/store/zonegroups/defaults.js